import {Injectable} from '@angular/core';

export interface Menu {
    state: string;
    name: string;
    icon: string;
    /** Shown only to admins. Cosmetic — /users is enforced by the API, not by hiding the link. */
    adminOnly?: boolean;
    /** Marked "New" in the menu. */
    isNew?: boolean;
}

/**
 * The console's sections, as the tabs in its header (layouts/full), in the desktop app's style.
 * The authoring pages share one tab, a menu; Settings is the gear beside the account.
 */
@Injectable()
export class MenuItems {
    // The Dashboard covers Test Cases (browse, counts, drill-in); /templates still works for links.
    readonly dashboard: Menu = {state: 'dashboard', name: 'Dashboard', icon: 'space_dashboard'};

    readonly authoring: Menu[] = [
        {state: 'studio-chat', name: 'Studio chat', icon: 'forum', isNew: true},
        {state: 'studio', name: 'Test Studio', icon: 'travel_explore'},
        {state: 'suite', name: 'Auto-Suite (UI)', icon: 'auto_awesome_motion'},
        {state: 'api-suite', name: 'API Suite', icon: 'api'},
    ];

    readonly operations: Menu[] = [
        {state: 'schedule', name: 'Schedule', icon: 'event_repeat'},
        {state: 'runs', name: 'Reports', icon: 'summarize'},
        {state: 'users', name: 'Users', icon: 'group', adminOnly: true},
    ];

    readonly settings: Menu = {state: 'settings', name: 'Settings', icon: 'settings'};
}
